import React, { forwardRef } from 'react';

export const FileUploadContainer = ({ children, className, ...props }) => {
  return (
    <section
      {...props}
      className={
        'relative flex flex-col align-center bg-white lg:border  lg:bg-gray-50 lg:border-gray-300 lg:border-dashed lg:p-8 lg:mt-8 lg:mb-0 transition ' +
        className
      }
    >
      {children}
    </section>
  );
};
export const FormField = forwardRef((props, ref) => {
  return (
    <input
      ref={ref}
      className={'w-full inset-0 opacity-0 block absolute focus:outline-none'}
      {...props}
    />
  );
});
export const InputLabel = ({ children, ...props }) => {
  return (
    <label className={'absolute left-0 -top-6 text-black'} {...props}>
      {children}
    </label>
  );
};

export const DragDropText = ({ children, ...props }) => {
  return (
    <p className={'hidden lg:block text-bold mt-0 text-center tracking-widest'} {...props}>
      {children}
    </p>
  );
};

export const UploadFileBtn = ({ children, ...props }) => {
  return (
    <button
      {...props}
      className={
        'border rounded-md py-1 border-2 padding-2 text-center uppercase relative z-1 m-2 flex justify-center'
      }
    >
      {children}
    </button>
  );
};

export const FilePreviewContainer = ({ children, className, ...props }) => {
  console.log(children);
  return (
    <article
      {...props}
      className={'text-md lg:mb-8 lg:border border-gray-600 border-dashed border-t-0 ' + className}
    >
      {children}
      {children &&
        children.props &&
        children.props.children &&
        children.props.children.length > 0 && (
          <span>Selected images: {children.props.children.length}</span>
        )}
    </article>
  );
};

export const PreviewList = ({ children, ...props }) => {
  return (
    <section {...props} className={'hidden lg:flex flex-wrap mt-2 overflow-auto'}>
      {children}
    </section>
  );
};

export const PreviewContainer = ({ children, ...props }) => {
  return (
    <section {...props} className={'p-1 w-1/5 lg:w-1/3 xl:w-1/4 aspect-square relative'}>
      {children}
    </section>
  );
};

export const ImagePreview = ({ alt, className, ...props }) => {
  return (
    <img
      {...props}
      alt={alt || 'Preview'}
      className={'w-full aspect-square object-cover ' + className}
    />
  );
};
